import type {DSConfig} from '../dsConfig'
import baseConfig from './editor3Config'

const config = {
    ...baseConfig
}

export default config as unknown as DSConfig
